"use client";

import { useTheme } from "@/app/context/ThemeContext";
import Navbar from "./components/Homapage/Navbar";
import Hero from "./components/Homapage/Hero";
import Footer from "./components/Homapage/Footer";
import NewsletterSection from "./components/NewsletterSection";
import NewsSection from "./components/NewsSection";
import SpecialtiesPage from "./components/specialties";

// import ProductsSection from "./components/ProductsSection";
import ProductsSection from "./components/ProductsSection";
import SectionWrapper from "./components/SectionWrapper";
import EventSection from "./components/EventSection";
import ConsentPopup from "./components/ConsentPopup";
import NosApp from "./components/NosApp";
import NosAppp from "./components/NosAppp";

export default function Home() {
  const { theme } = useTheme();

  // Background and text colors based on theme           <EventSection />

  const bgPage =
    theme === "dark" ? "bg-gray-900 text-gray-100" : "bg-gradient-to-br from-rose-50 to-amber-50 text-gray-800";

  return (
    <div className={`min-h-screen transition-colors duration-300 ${bgPage}`}>

      <Navbar />
      <main className="relative">
        <section id="home" className="relative">
          <Hero />
        </section>
        <SectionWrapper
          id="specialties"
          titleColor={theme === "dark" ? "text-amber-400" : "text-amber-600"}
          bgClass={theme === "dark" ? "bg-gray-900/80" : "bg-amber-50/80"}
        >
          <SpecialtiesPage />
        </SectionWrapper>
        <SectionWrapper
          id="Events"
          titleColor={theme === "dark" ? "text-rose-400" : "text-rose-600"}
          bgClass={theme === "dark" ? "bg-gray-800/80 backdrop-blur-sm" : "bg-white/60 backdrop-blur-sm"}
        >
          <EventSection />
        </SectionWrapper>
        <SectionWrapper
          id="news"
          titleColor={theme === "dark" ? "text-rose-400" : "text-rose-600"}
          bgClass={theme === "dark" ? "bg-gray-800/80 backdrop-blur-sm" : "bg-white/60 backdrop-blur-sm"}
        >
          <NewsSection />
        </SectionWrapper>

        <SectionWrapper
          id="products"
          titleColor={theme === "dark" ? "text-emerald-400" : "text-emerald-600"}
          bgClass={theme === "dark" ? "bg-gray-800/80 backdrop-blur-sm" : "bg-white/60 backdrop-blur-sm"}
        >
          <ProductsSection />
        </SectionWrapper>

{/*
        <SectionWrapper
          id="products"
          titleColor={theme === "dark" ? "text-emerald-400" : "text-emerald-600"}
          bgClass={theme === "dark" ? "bg-gray-800/80 backdrop-blur-sm" : "bg-white/60 backdrop-blur-sm"}
        >
          <NosAppp />
        </SectionWrapper> 
        <SectionWrapper
          id="newsletter"
          titleColor={theme === "dark" ? "text-rose-400" : "text-rose-700"}
          bgClass={
            theme === "dark"
              ? "bg-gradient-to-r from-gray-700 to-gray-900"
              : "bg-gradient-to-r from-rose-100 to-amber-100"
          }
        >
          <NewsletterSection />
        </SectionWrapper>
*/}
      </main>
      <Footer />
    </div>
  );
}






/*


        <SectionWrapper
          id="products"
          titleColor={theme === "dark" ? "text-emerald-400" : "text-emerald-600"}
          bgClass={theme === "dark" ? "bg-gray-800/80 backdrop-blur-sm" : "bg-white/60 backdrop-blur-sm"}
        >
          <NosApp/>
        </SectionWrapper>

        
"use client";

import { useTheme } from "@/app/context/ThemeContext";
import Navbar from "./components/Homapage/Navbar";
import Hero from "./components/Homapage/Hero";
import Footer from "./components/Homapage/Footer";
import NewsletterSection from "./components/NewsletterSection";
import NewsSection from "./components/NewsSection";
import SpecialtiesPage from "./components/specialties";
// import ProductsSection from "./components/ProductsSection";
import ProductsSection from "./components/ProductsSection";
import SectionWrapper from "./components/SectionWrapper";
import EventSection from "./components/EventSection";

export default function Home() {
  const { theme } = useTheme();

  // Background and text colors based on theme
  const bgPage =
    theme === "dark" ? "bg-gray-900 text-gray-100" : "bg-gradient-to-br from-rose-50 to-amber-50 text-gray-800";

  return (
    <div className={`min-h-screen transition-colors duration-300 ${bgPage}`}>
      <Navbar />

      <main className="relative">
        <section id="home" className="relative">
          <Hero />
        </section>

        <SectionWrapper
          id="Events"
          titleColor={theme === "dark" ? "text-rose-400" : "text-rose-600"}
          bgClass={theme === "dark" ? "bg-gray-800/80 backdrop-blur-sm" : "bg-white/60 backdrop-blur-sm"}
        >
          <EventSection />
        </SectionWrapper>

        <SectionWrapper
          id="news"
          titleColor={theme === "dark" ? "text-rose-400" : "text-rose-600"}
          bgClass={theme === "dark" ? "bg-gray-800/80 backdrop-blur-sm" : "bg-white/60 backdrop-blur-sm"}
        >
          <NewsSection />
        </SectionWrapper>

        <SectionWrapper
          id="specialties"
          titleColor={theme === "dark" ? "text-amber-400" : "text-amber-600"}
          bgClass={theme === "dark" ? "bg-gray-900/80" : "bg-amber-50/80"}
        >
          <SpecialtiesPage />
        </SectionWrapper>

        <SectionWrapper
          id="products"
          titleColor={theme === "dark" ? "text-emerald-400" : "text-emerald-600"}
          bgClass={theme === "dark" ? "bg-gray-800/80 backdrop-blur-sm" : "bg-white/60 backdrop-blur-sm"}
        >
          <ProductsSection />
        </SectionWrapper>

        <SectionWrapper
          id="newsletter"
          titleColor={theme === "dark" ? "text-rose-400" : "text-rose-700"}
          bgClass={
            theme === "dark"
              ? "bg-gradient-to-r from-gray-700 to-gray-900"
              : "bg-gradient-to-r from-rose-100 to-amber-100"
          }
        >
          <NewsletterSection />
        </SectionWrapper>
      </main>

      <Footer />
    </div>
  );
}


*/




/*
// app/page.tsx
import Navbar from "./components/Homapage/Navbar";
import Hero from "./components/Homapage/Hero";
import Footer from "./components/Homapage/Footer";
import NewsletterSection from "./components/NewsletterSection";
import NewsSection from "./components/NewsSection";
import SpecialtiesPage from "./components/specialties";
//import ProductsSection from "./components/ProductsSection";
import ProductsSection from "../app/ProductsSection/page";
import SectionWrapper from "./components/SectionWrapper";
import EventSection from "./components/EventSection";

export default function Home() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-rose-50 to-amber-50 text-gray-800">
      <Navbar />

      <main className="relative">
        <section id="home" className="relative">
          <Hero />
        </section>
        <SectionWrapper
          id="Events"
          titleColor="text-rose-600"
          bgClass="bg-white/60 backdrop-blur-sm"
        >
          <EventSection />
        </SectionWrapper>
        <SectionWrapper
          id="news"
          titleColor="text-rose-600"
          bgClass="bg-white/60 backdrop-blur-sm"
        >
          <NewsSection />
        </SectionWrapper>
        <SectionWrapper
          id="specialties"
          titleColor="text-amber-600"
          bgClass="bg-amber-50/80"
      >
          <SpecialtiesPage />
        </SectionWrapper>


        <SectionWrapper
          id="products"
          titleColor="text-emerald-600"
          bgClass="bg-white/60 backdrop-blur-sm"
        >
          <ProductsSection />
        </SectionWrapper>

        <SectionWrapper
          id="newsletter"
 
          titleColor="text-rose-700"
          bgClass="bg-gradient-to-r from-rose-100 to-amber-100"
        >
          <NewsletterSection />
        </SectionWrapper>
      </main>

      <Footer />
    </div>
  );
}
*/